import * as actionTypes from "../actionTypes";

// account-settings
export const changeSettingValue = (valType, payload) => ({
  type: actionTypes.SETTING_VALUE_CHANGE,
  valType,
  payload,
});

export const accountSettingData = () => ({
  type: actionTypes.ACCOUNT_SETTING_DETAILS,
});

export const uploadAccLogo = (payload, fromType = "account") => ({
  type: actionTypes.UPLOAD_ACC_LOGO,
  payload,
  fromType,
});

export const companySettingData = (merchantId) => ({
  type: actionTypes.COMPANY_SETTING_DETAILS,
  merchantId,
});

export const clearCompanySettingData = () => ({
  type: actionTypes.COMPANY_SETTING_DETAILS_FAILED,
  payload: { company_setting: null },
});

export const uploadAccDocument = (
  payload,
  query = "",
  merchantInfoId,
  fromType = "companySettings"
) => ({
  type: actionTypes.UPLOAD_ACC_DOCUMENT,
  payload,
  query,
  merchantInfoId,
  fromType,
});
export const deleteAccDocument = (
  payload,
  merchantInfoId,
  fromType = "companySettings"
) => ({
  type: actionTypes.DELETE_ACC_DOCUMENT,
  payload,
  merchantInfoId,
  fromType,
});
export const updatePostingPeriodStatus = (
  payload,
  merchantInfoId,
  fromType = "companySettings"
) => ({
  type: actionTypes.UPDATE_POSTING_PERIOD_STATUS,
  payload,
  merchantInfoId,
  fromType,
});

export const getCompanyName = (merchantId = "") => ({
  type: actionTypes.GET_COMPANY_NAME,
  merchantId,
});

export const scheduleCompanyName = (payload, merchantInfoId) => ({
  type: actionTypes.SCHEDULE_COMPANY_NAME,
  payload,
  merchantInfoId,
});

export const toggleCompanyNameModal = (toggle) => ({
  type: toggle
    ? actionTypes.SETTING_COMPANY_NAME_MODAL_SHOW
    : actionTypes.SETTING_COMPANY_NAME_MODAL_HIDE,
});

export const toggleSettingDocModal = (toggle) => ({
  type: toggle
    ? actionTypes.SETTING_DOC_MODAL_SHOW
    : actionTypes.SETTING_DOC_MODAL_HIDE,
});
export const toggleSettingAccModal = (toggle) => ({
  type: toggle
    ? actionTypes.SETTING_ACCOUNTING_MODAL_SHOW
    : actionTypes.SETTING_ACCOUNTING_MODAL_HIDE,
});

export const codeListData = () => ({
  type: actionTypes.CODE_LIST_DETAILS,
});

export const addCodeData = () => ({
  type: actionTypes.ADD_CODE_DETAILS,
});

export const deleteCodeData = (payload) => ({
  type: actionTypes.DELETE_CODE_DETAILS,
  payload,
});

export const accountManagementData = (merchantId, userId) => ({
  type: actionTypes.ACCOUNT_MANAGEMENT_DETAILS,
  query: `/${merchantId}/${userId}`,
});

export const saveAccountManagement = (payload) => ({
  type: actionTypes.SAVE_ACCOUNT_MANAGEMENT_DETAILS,
  payload,
});
export const updateAccountAdmin = (payload) => ({
  type: actionTypes.UPDATE_ACCOUNT_ADMIN,
  payload,
});
export const updatePlanCost = (payload) => ({
  type: actionTypes.UPDATE_PLAN_COST,
  payload,
});
export const updatePlanTopup = (payload) => ({
  type: actionTypes.UPDATE_PLAN_TOPUP,
  payload,
});

export const updatePosCount = (payload) => ({
  type: actionTypes.UPDATE_POS_COUNT,
  payload,
});

export const getPaymentOwnerSubAccounts = (ownerId) => ({
  type: actionTypes.GET_OWNER_SUBACC,
  query: `/${ownerId}`,
});

export const savePaymentInfo = (payload) => ({
  type: actionTypes.SAVE_PAYMENT_INFO,
  payload,
});
export const cancelAccount = (payload) => ({
  type: actionTypes.CANCEL_ACCOUNT,
  payload,
});
export const getInvoiceList = (payload) => ({
  type: actionTypes.GET_INVOICE_LIST,
  payload,
});
export const getInvoiceDetails = (merchantId, id) => ({
  type: actionTypes.GET_INVOICE_DETAILS,
  query: `/${merchantId}/${id}`,
});

// user management
export const getUserManagementDetails = () => ({
  type: actionTypes.GET_USER_MANAGE_DETAILS,
});
export const updateUserManagementDetails = (payload, selectedArr) => ({
  type: actionTypes.UPDATE_USER_MANAGE_DETAILS,
  payload,
  selectedArr,
});
export const addLinkedEmployee = (payload) => ({
  type: actionTypes.ADD_LINKED_EMP,
  payload,
});
export const getMerchantUserList = (payload) => ({
  type: actionTypes.GET_MERCHANT_USER_LIST,
  payload,
});
export const getPermissionGroupList = (payload) => ({
  type: actionTypes.GET_PERMISSION_GROUP_LIST,
  payload,
});

// cluster settings
export const getClusterSettings = () => ({
  type: actionTypes.GET_CLUSTER_SETTINGS,
});
export const addClusterdetails = () => ({
  type: actionTypes.ADD_CLUSTER_DETAILS,
});
export const saveClusterdetails = (payload) => ({
  type: actionTypes.SAVE_CLUSTER_DETAILS,
  payload,
});
export const getClusterModules = (payload) => ({
  type: actionTypes.GET_CLUSTER_MODULES,
  payload,
});
export const addClusterAccess = (payload) => ({
  type: actionTypes.ADD_CLUSTER_ACCESS,
  payload,
});
export const addClusterStore = (payload) => ({
  type: actionTypes.ADD_CLUSTER_STORE,
  payload,
});

/* finance - settings */
// general settings
export const getFinanceGeneralSettings = () => ({
  type: actionTypes.GET_FINANCE_GENERAL_SETTINGS,
});
export const saveFinanceGeneralSettings = (payload) => ({
  type: actionTypes.SAVE_FINANCE_GENERAL_SETTINGS,
  payload,
});
export const getFinanceSaleSettings = () => ({
  type: actionTypes.GET_FINANCE_SALE_SETTINGS,
});
export const getGroupAccList = (id) => ({
  type: actionTypes.GET_GROUP_ACC_LIST,
  query: "/" + id,
});
export const savePaymentMethod = (payload) => ({
  type: actionTypes.SAVE_PAYMENT_METHOD,
  payload,
});
export const deletePaymentMethod = (payload) => ({
  type: actionTypes.DELETE_PAYMENT_METHOD_ORDER,
  payload,
});
export const updatePmOrdering = (payload) => ({
  type: actionTypes.UPDATE_PAYMENT_METHOD_ORDER,
  payload,
});
export const saveServicePeriod = (payload) => ({
  type: actionTypes.SAVE_SERVICE_PERIOD,
  payload,
});
export const deleteServicePeriod = (payload) => ({
  type: actionTypes.DELETE_SERVICE_PERIOD,
  payload,
});
export const saveSaleType = (payload) => ({
  type: actionTypes.SAVE_SALE_TYPE,
  payload,
});
export const deleteSaleType = (payload) => ({
  type: actionTypes.DELETE_SALE_TYPE,
  payload,
});
export const saveSaleGroup = (payload) => ({
  type: actionTypes.SAVE_SALE_GROUP,
  payload,
});
export const deleteSaleGroup = (payload) => ({
  type: actionTypes.DELETE_SALE_GROUP,
  payload,
});
export const saveChannel = (payload) => ({
  type: actionTypes.SAVE_CHANNEL,
  payload,
});
export const deleteChannel = (payload) => ({
  type: actionTypes.DELETE_CHANNEL,
  payload,
});
export const getPublicHoliday = () => ({
  type: actionTypes.GET_PUBLIC_HOLIDAY,
});
export const savePublicHoliday = (payload) => ({
  type: actionTypes.SAVE_PUBLIC_HOLIDAY,
  payload,
});
export const deletePublicHoliday = (payload) => ({
  type: actionTypes.DELETE_PUBLIC_HOLIDAY,
  payload,
});
export const updateMatrixFinanceSale = (payload) => ({
  type: actionTypes.UPDATE_MATRIX_FINANCE,
  payload,
});
export const getMasterSetting = () => ({
  type: actionTypes.GET_MASTER_SETTING,
});
export const savePmMasterSetting = (payload) => ({
  type: actionTypes.SAVE_PM_MASTER_SETTING,
  payload,
});
export const updatePmMasterSetting = (payload) => ({
  type: actionTypes.UPDATE_PM_MASTER_SETTING,
  payload,
});
export const updatePmMasterSettingStatus = (payload) => ({
  type: actionTypes.UPDATE_PM_MASTER_SETTING_STATUS,
  payload,
});
export const refreshPmMasterSetting = (payload) => ({
  type: actionTypes.REFRESH_PM_MASTER_SETTING,
  payload,
});

export const saveSalesMasterSetting = (payload) => ({
  type: actionTypes.SAVE_SALES_MASTER_SETTING,
  payload,
});
export const updateSalesMasterSetting = (payload) => ({
  type: actionTypes.UPDATE_SALES_MASTER_SETTING,
  payload,
});
export const updateSalesMasterSettingStatus = (payload) => ({
  type: actionTypes.UPDATE_SALES_MASTER_SETTING_STATUS,
  payload,
});
export const refreshSalesMasterSetting = (payload) => ({
  type: actionTypes.REFRESH_SALES_MASTER_SETTING,
  payload,
});

export const saveServicePeriodsMasterSetting = (payload) => ({
  type: actionTypes.SAVE_SERVICE_PERIOD_MASTER_SETTING,
  payload,
});
export const updateServicePeriodsMasterSetting = (payload) => ({
  type: actionTypes.UPDATE_SERVICE_PERIOD_MASTER_SETTING,
  payload,
});
export const updateServicePeriodsMasterSettingStatus = (payload) => ({
  type: actionTypes.UPDATE_SERVICE_PERIOD_MASTER_SETTING_STATUS,
  payload,
});
export const refreshServicePeriodsMasterSetting = (payload) => ({
  type: actionTypes.REFRESH_SERVICE_PERIOD_MASTER_SETTING,
  payload,
});

export const saveChannelsMasterSetting = (payload) => ({
  type: actionTypes.SAVE_CHANNELS_MASTER_SETTING,
  payload,
});
export const updateChannelsMasterSetting = (payload) => ({
  type: actionTypes.UPDATE_CHANNELS_MASTER_SETTING,
  payload,
});
export const updateChannelsMasterSettingStatus = (payload) => ({
  type: actionTypes.UPDATE_CHANNELS_MASTER_SETTING_STATUS,
  payload,
});
export const refreshChannelsMasterSetting = (payload) => ({
  type: actionTypes.REFRESH_CHANNELS_MASTER_SETTING,
  payload,
});
// charts of accounts
export const getFinanceChartOfAccSettings = (query = "") => ({
  type: actionTypes.GET_FINANCE_CHARTS_OF_ACC_SETTINGS,
  query,
});
export const getFinanceAccounts = (queryData = {}) => ({
  type: actionTypes.GET_FINANCE_ACCOUNTS,
  queryData,
});
export const addFinanceAccountDetails = (query = "") => ({
  type: actionTypes.ADD_FINANCE_ACCOUNTS,
  query,
});
export const downloadAllFinanceAcc = (query = "") => ({
  type: actionTypes.DOWNLOAD_ALL_FINANCE_ACCOUNTS,
  query,
});
export const addFinanceSubAccountDetails = (query = "") => ({
  type: actionTypes.ADD_FINANCE_SUB_ACCOUNTS,
  query,
});
export const saveFinanceSubAccountDetails = (query = "", payload) => ({
  type: actionTypes.SAVE_FINANCE_SUB_ACCOUNTS,
  query,
  payload,
});
export const getUpdateFinanceSubAccountDetails = (query = "") => ({
  type: actionTypes.GET_UPDATE_FINANCE_SUB_ACCOUNTS,
  query,
});
export const getSubAccountTransactionsDetails = (query = "", payload) => ({
  type: actionTypes.GET_SUB_ACCOUNT_TRANSACTIONS,
  query,
  payload,
});
export const saveEditSubAccountDetails = (query = "", payload, isSave) => ({
  type: actionTypes.SAVE_EDIT_SUB_ACCOUNT,
  query,
  payload,
  isSave,
});
export const getAddTransSubAccountDetails = (query = "") => ({
  type: actionTypes.GET_ADD_TRANS_SUB_ACCOUNTS,
  query,
});
export const getDebitCreditAccountDetails = (payload = {}, accType = "") => ({
  type: actionTypes.GET_DEBIT_CREDIT_ACCOUNT,
  payload,
  accType,
});
export const saveAccTransactionDetails = (query = "", payload) => ({
  type: actionTypes.SAVE_ACCOUNT_TRANSACTION,
  query,
  payload,
});

// Forecast
export const getFinanceForecastSettings = (query = "") => ({
  type: actionTypes.GET_FINANCE_FORECAST_SETTINGS,
  query,
});
export const getForecastRulesDetails = (query = "", ruleType = 1) => ({
  type: actionTypes.GET_FORECAST_RULE,
  query: `/${query}`,
  ruleType,
});
export const getApplicableQuarterDetails = (payload) => ({
  type: actionTypes.GET_APPLICABLE_QUARTER,
  payload,
});
export const saveFinanceForecastSettings = (payload) => ({
  type: actionTypes.SAVE_FINANCE_FORECAST_SETTINGS,
  payload,
});
export const editFinanceRuleDetail = (query = "") => ({
  type: actionTypes.EDIT_FINANCE_RULE,
  query,
});
export const updateFinanceRuleDetail = (query = "", payload) => ({
  type: actionTypes.UPDATE_FINANCE_RULE,
  query,
  payload,
});

// Reconcile
export const getFinanceReconcileSettings = (query = "") => ({
  type: actionTypes.GET_RECONSILE_SETTINGS,
  query,
});
export const addFinanceReconcileSettings = (payload) => ({
  type: actionTypes.ADD_RECONSILE_SETTINGS,
  payload,
});
export const deleteFinanceReconcileSettings = (payload) => ({
  type: actionTypes.DELETE_RECONSILE_SETTINGS,
  payload,
});
export const getReconcileUploadSettings = (query = "") => ({
  type: actionTypes.GET_RECONSILE_UPLOAD_SETTINGS,
  query,
});
export const saveReconcileUploadSettings = (query = "", payload) => ({
  type: actionTypes.SAVE_RECONSILE_UPLOAD_SETTINGS,
  query,
  payload,
});

// QR ORDERING

export const getQrOrderData = (payload) => ({
  type: actionTypes?.GET_QR_ORDER_DATA,
  payload,
});

export const saveQrOrderData = (payload) => ({
  type: actionTypes?.SAVE_QR_ORDER_DATA,
  payload,
});

export const postQrOrderData = (payload) => ({
  type: actionTypes?.POST_QR_ORDER_DATA,
  payload,
});

export const postPdfMenu = (payload) => ({
  type: actionTypes?.POST_PDF_MENU,
  payload,
});

export const editSavePdfMenuData = (payload) => ({
  type: actionTypes?.EDIT_SAVE_PDF_MENU_DATA,
  payload,
});

export const editPostPdfMenuData = (payload) => ({
  type: actionTypes?.EDIT_POST_PDF_MENU_DATA,
  payload,
});

export const saveUpdatedPdfMenu = (payload) => ({
  type: actionTypes?.SAVE_UPDATED_PDF_MENU_DATA,
  payload,
});

export const getMenuSequencingData = (payload) => ({
  type: actionTypes?.GET_MENU_SEQUENCING_DATA,
  payload,
});

export const saveMenuSequencingData = (payload) => ({
  type: actionTypes?.SAVE_MENU_SEQUENCING_DATA,
  payload,
});

export const postMenuSequencingData = (payload) => ({
  type: actionTypes?.POST_MENU_SEQUENCING_DATA,
  payload,
});

export const getQrList = (payload) => ({
  type: actionTypes?.GET_QR_LIST,
  payload,
});

export const saveQrList = (payload) => ({
  type: actionTypes?.SAVE_QR_LIST,
  payload,
});

export const downloadQrList = (payload) => ({
  type: actionTypes?.DOWNLOAD_QR_LIST,
  payload,
});

export const downloadSelectedQr = (payload) => ({
  type: actionTypes?.DOWNLOAD_SELECTED_QR,
  payload,
});

export const regenerateSelectedQr = (payload) => ({
  type: actionTypes?.REGENERATE_SELECTED_QR,
  payload,
});

export const refreshTableQrCode = (payload) => ({
  type: actionTypes?.REFRESH_TABLE_QR_CODE,
  payload,
});

export const getOrdrrOnlineMenuSequencingData = (payload) => ({
  type: actionTypes?.GET_ORDRR_ONLINE_MENU_SEQUENCING_DATA,
  payload,
});

export const saveOrdrrOnlineMenuSequencingData = (payload) => ({
  type: actionTypes?.SAVE_ORDRR_ONLINE_MENU_SEQUENCING_DATA,
  payload,
});

export const postOrdrrOnlineMenuSequencingData = (payload) => ({
  type: actionTypes?.POST_ORDRR_ONLINE_MENU_SEQUENCING_DATA,
  payload,
});

export const getOrdrrOnlineData = (payload) => ({
  type: actionTypes?.GET_ORDRR_ONLINE_DATA,
  payload,
});

export const saveOrdrrOnlineData = (payload) => ({
  type: actionTypes?.SAVE_ORDRR_ONLINE_DATA,
  payload,
});

export const postOrdrrOnlineData = (payload) => ({
  type: actionTypes?.POST_ORDRR_ONLINE_DATA,
  payload,
});

export const getDeliveryPartnerData = (payload) => ({
  type: actionTypes?.GET_DELIVERY_PARTNER_DATA,
  payload,
});

export const saveDeliveryPartnerData = (payload) => ({
  type: actionTypes?.SAVE_DELIVERY_PARTNER_DATA,
  payload,
});

export const postDeliveryPartnerData = (payload) => ({
  type: actionTypes?.POST_DELIVERY_PARTNER_DATA,
  payload,
});

export const addDeliveryPartner = (payload) => ({
  type: actionTypes?.ADD_DELIVERY_PARTNER,
  payload,
});

export const editDeliveryPartner = (payload) => ({
  type: actionTypes?.EDIT_DELIVERY_PARTNER,
  payload,
});

export const deleteDeliveryPartner = (payload) => ({
  type: actionTypes?.DELETE_DELIVERY_PARTNER,
  payload,
});

export const getApiKeyListing = (payload) => ({
  type: actionTypes?.GET_API_KEY_LISTING,
  payload,
});

export const saveApiListing = (payload) => ({
  type: actionTypes?.SAVE_API_KEY_LISTING,
  payload,
});

export const postConfirmPassword = (payload) => ({
  type: actionTypes?.POST_CONFIRM_PASSWORD,
  payload,
});

export const saveConfirmPasswordStatus = (payload) => ({
  type: actionTypes?.SAVE_CONFIRM_PASSWORD_STATUS,
  payload,
});

export const postDeleteApiKey = (payload) => ({
  type: actionTypes?.POST_DELETE_API_KEY,
  payload,
});

export const postGenerateApikey = (payload) => ({
  type: actionTypes?.POST_GENERATE_API_KEY,
  payload,
});

export const getIntegrationData = (payload) => ({
  type: actionTypes?.GET_INTEGRATION_DATA,
  payload,
});

export const saveIntegrationData = (payload) => ({
  type: actionTypes?.SAVE_INTEGRATION_DATA,
  payload,
});

export const postPackageStatus = (payload) => ({
  type: actionTypes?.POST_PACKAGE_STATUS,
  payload,
});

export const getIntegrationEditData = (payload) => ({
  type: actionTypes?.GET_INTEGRATION_EDIT_DATA,
  payload,
});

export const saveIntegrationEditData = (payload) => ({
  type: actionTypes?.SAVE_INTEGRATION_EDIT_DATA,
  payload,
});

export const postIntegrationEditData = (payload) => ({
  type: actionTypes?.POST_INTEGRATION_EDIT_DATA,
  payload,
});

export const postPauseStore = (payload) => ({
  type: actionTypes?.POST_PAUSE_STORE,
  payload,
});
